import { render, staticRenderFns } from "./newDataIndex.vue?vue&type=template&id=d61db3c8&scoped=true&"
import script from "./newDataIndex.vue?vue&type=script&lang=js&"
export * from "./newDataIndex.vue?vue&type=script&lang=js&"
import style0 from "./newDataIndex.vue?vue&type=style&index=0&id=d61db3c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61db3c8",
  null
  
)

export default component.exports